import type { ReactNode } from 'react'
import { useAuth } from '../hooks/useAuth'

type UserRole = 'admin' | 'planner' | 'vendor' | 'driver' | 'family' | 'guest'

interface RequireRoleProps {
  role: UserRole | UserRole[]
  children: ReactNode
  fallback?: ReactNode
}

export default function RequireRole({ role, children, fallback = null }: RequireRoleProps) {
  const { claims, loading } = useAuth()

  if (loading) return null

  const userRole = claims?.role
  if (!userRole) return <>{fallback}</>

  const allowedRoles = Array.isArray(role) ? role : [role]
  const hasRequiredRole = allowedRoles.includes(userRole as UserRole)

  if (!hasRequiredRole) return <>{fallback}</>

  return <>{children}</>
}
